var getRadius = function (baseUnit, round) {
    if (round === true)
        return "".concat(baseUnit, "px");
    if (typeof round === "number")
        return "".concat(baseUnit * round, "px");
    if (typeof round === "string")
        return round;
    return "";
};
var topLeft = function (baseUnit, size) { return "border-top-left-radius: ".concat(getRadius(baseUnit, size), ";"); };
var topRight = function (baseUnit, size) { return "border-top-right-radius: ".concat(getRadius(baseUnit, size), ";"); };
var bottomLeft = function (baseUnit, size) { return "border-bottom-left-radius: ".concat(getRadius(baseUnit, size), ";"); };
var bottomRight = function (baseUnit, size) { return "border-bottom-right-radius: ".concat(getRadius(baseUnit, size), ";"); };
var radiusMap = {
    top: function (baseUnit, size) { return "\n    ".concat(topLeft(baseUnit, size), "\n    ").concat(topRight(baseUnit, size), "\n  "); },
    left: function (baseUnit, size) { return "\n    ".concat(topLeft(baseUnit, size), "\n    ").concat(bottomLeft(baseUnit, size), "\n  "); },
    bottom: function (baseUnit, size) { return "\n    ".concat(bottomLeft(baseUnit, size), "\n    ").concat(bottomRight(baseUnit, size), "\n  "); },
    right: function (baseUnit, size) { return "\n    ".concat(topRight(baseUnit, size), "\n    ").concat(bottomRight(baseUnit, size), "\n  "); },
    "top-left": topLeft,
    "top-right": topRight,
    "bottom-left": bottomLeft,
    "bottom-right": bottomRight,
};
export default (function (_a) {
    var baseUnit = _a.theme.constants.SIZE_SUB_UNIT, round = _a.round;
    if (!round)
        return "";
    var value = getRadius(baseUnit, round);
    if (value)
        return "border-radius: ".concat(value, ";");
    var side = round.side, _b = round.size, size = _b === void 0 ? 1 : _b;
    return side in radiusMap ? "".concat(radiusMap[side](baseUnit, size)) : "";
});
